import { observable, toJS } from 'mobx';
import AssetLabelModel from './AssetLabelModel';

export default class AssetSceneModel {
    id = null;
    @observable type = null;
    @observable generator = null;
    @observable name = null;
    @observable tcInMs = null;
    @observable tcOutMs = null;
    @observable thumbnailUrl = null;
    @observable thumbnails = null;
    @observable labels = null;

    constructor(id, type, generator, name, tcInMs, tcOutMs, thumbnailUrl, thumbnails, labels) {
        this.id = id;
        this.type = type;
        this.generator = generator;
        this.name = name;
        this.tcInMs = tcInMs;
        this.tcOutMs = tcOutMs;
        this.thumbnailUrl = thumbnailUrl;
        this.thumbnails = thumbnails;
        this.labels = labels;
    }

    toJS() {
        toJS(this);
    }

    static fromJS(object) {
        const labels = object.labels ? object.labels.map(l => AssetLabelModel.fromJS(l)) : [];
        return new AssetSceneModel(
            object.id, object.type, object.generator, object.name, object.tc_in_ms,
            object.tc_out_ms, object.thumbnail_url, object.thumbnails, labels,
        );
    }
}
